import { useState, useEffect } from 'react';
import { formsApi } from '../../../services/api';
import { FormSchema } from '../../../types/form';
import { showError } from '../../../utils/toast';

export const useFormById = (id: number | null) => {
  const [form, setForm] = useState<FormSchema | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchForm = async () => {
    if (!id) return;
    
    setLoading(true);
    setError(null);
    try {
      const data = await formsApi.getById(id);
      setForm(data);
    } catch (err: any) {
      const errorMessage = err.response?.data?.message || 'Failed to fetch form';
      setError(errorMessage);
      showError(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchForm();
    }
  }, [id]);

  return {
    form,
    loading,
    error,
    refetch: fetchForm,
  };
};
